import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import { ReportContext } from '../../../../src/app'
import BarPostReport from './BarPostReport'

import { HeaderContainer, MainContainer, TileContainer } from './FrameHome'

interface Props {
    history: any[]
    location: {
        pathname: string
    }
    match: {
        params: {
            uid: string
        }
    }
}



export default function ReportHeader({ ...props }: Props): JSX.Element {
    const pathLocation = props.location.pathname
    const context = useContext(ReportContext)

    return (
        <HeaderContainer>
            <MainContainer>
                <TileContainer>
                    <span>APPS</span>
                    <label>Reports Maker</label>
                </TileContainer>
                {((): JSX.Element => {
                    switch (pathLocation) {
                        case '/':
                                break
                        default:
                            return (
                                <TileContainer>
                                    <BarPostReport report={context.report} />
                                </TileContainer>
                            )
                    }
                })()}
                
            </MainContainer>
        </HeaderContainer>
    )
}
